import angular from 'angular';

angular.module('cloudX').directive('cxLanguageSelect', [
  function() {
    return {
      restrict: 'E',
      template:
        '<a href="#" class="form-control-static" editable-select="language" onbeforesave="save({newValue:$data})" e-ng-options="(language | translateList:\'language\') for language in languages" edit-disabled="disabled">' +
        "<span>{{language | translateList:'language'}}</span></a>",
      scope: {
        language: '=data',
        save: '&',
        disabled: '=?',
      },
      controller: [
        '$scope',
        'optionsSvc',
        function($scope, optionsSvc) {
          $scope.languages = optionsSvc.getOptions('language');
        },
      ],
    };
  },
]);
